import React from 'react';
import ColorTag from '../ColorTag/ColorTag';

interface ColorTagAdminProps {}

const ColorTagAdmin: React.FC<ColorTagAdminProps> = props => {
  return <ColorTag className="ColorTagAdmin" color="firebrick" appearance="translucent">Admin</ColorTag>
}

export default ColorTagAdmin;